<template>
  <div class="container">
    <div class="scrollable">
      <div class="content">
        <div class="title">{{ content.title }}</div>
        <div class="content-container">
          <div class="img" :style="{backgroundImage: 'url(' + imgUrl + ')'}"></div>
          <div class="content-description" v-html="content.description"></div>
        </div>
      </div>
    </div>
    <LovalFooter :links="links" />
  </div>
</template>

<script>
import LovalFooter from '../LovalFooter'
export default {
  components: {
    LovalFooter
  },
  props: ['content', 'links'],
  data () {
    return {}
  },
  computed: {
    imgUrl () {
      return require('../../assets/img/' + this.content.image)
    }
  }
}
</script>
<style lang="scss" scoped>
@import url("./style.scss");
@import url("./industries-style.scss");
.img {
  height: 120px;
  background-size: cover;
  background-position: center;
}
.scrollable {
  height: calc(100% - var(--loval-footer-height));
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}
@media only screen and (min-width: 768px) {
  .scrollable {
    padding: 30px;
  }
  .content-container {
    display: flex;
  }
  .img {
    height: unset;
    width: 60%;
    min-height: 300px;
  }
  .content-description {
    width: 40%;
    padding-left: 20px;
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    padding: 20px 30px;
    background: var(--very-light-blue);
    border-top-left-radius: 30px;
    min-height: calc(100% - 40px);
  }
}
</style>
